import { useLocation } from 'react-router-dom'

const ORG_HANDLE_PATH_RE = /\/(?:organizations|payments|form-letters)\/([^/]+)/

export const getOrgHandleFromPathname = (pathname: string): string | null =>
  pathname.match(ORG_HANDLE_PATH_RE)?.[1] ?? null

// URLs use dashed handles (e.g. `tillamook-county`) while identities store
// underscored ones (`tillamook_county`), so compare in a canonical form.
export const orgHandlesMatch = (
  a: string | null | undefined,
  b: string | null | undefined,
): boolean => a != null && b != null && a.replace(/-/g, '_') === b.replace(/-/g, '_')

export const useUrlOrganizationHandle = (): string | null =>
  getOrgHandleFromPathname(useLocation().pathname)
